export default function ExecuteGraphQlQuery(
  query,
  variables,
  needsAuthorizedScopes = true,
) {
  const headers = {
    'Content-Type': 'application/json',
  }
  if (needsAuthorizedScopes) {
    headers['X-Shopify-Storefront-Access-Token'] = SAXX.Shop.APIKey
  }

  return fetch(`${window.Shopify.routes.root}api/2025-10/graphql.json`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      query,
      variables,
    }),
  }).then((res) => res.json())
}
